<template>
  <ul
    class="cn-breadcrumbs"
    itemscope
    itemtype="https://schema.org/BreadcrumbList"
  >
    <li
      v-for="(link, i) in links"
      :key="link.title"
      class="cn-breadcrumbs__item"
      :class="{ 'cn-breadcrumbs__item--last': isLastItem(i) }"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
    >
      <component
        :is="link.link ? 'ui-link' : 'span'"
        :to="link.link"
        class="cn-breadcrumbs__breadcrumb"
        :title="link.title"
        itemprop="item"
      >
        <span itemprop="name" :class="{ truncate: isLastItem(i) }">
          {{ link.title }}
        </span>
        <meta itemprop="position" :content="`${i}`" />
        <UiIcon v-if="!isLastItem(i)" name="chevron-right" />
      </component>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import UiIcon from '@/components/ui/UiIcon';

interface Props {
  items: {
    title: string;
    link?: string;
  }[];
}

const props = defineProps<Props>();

const links = computed(() => {
  return [
    {
      title: 'Canyon',
      link: '/',
    },
    ...props.items,
  ];
});

const isLastItem = (index: number) => index === links.value.length - 1;
</script>
<style lang="scss">
.cn-breadcrumbs {
  --ab-canyon-breadcrumbs-breadcrumb-color-text: var(--ab-canyon-color-dark);
  --ab-canyon-breadcrumbs-breadcrumb-color-text-last: var(
    --ab-canyon-color-neutral-dark
  );

  padding-top: var(--size-base);
  padding-bottom: var(--size-base);
  align-items: flex-start;
  flex-wrap: wrap;
  display: flex;
  &__breadcrumb {
    color: var(--ab-canyon-breadcrumbs-breadcrumb-color-text);
    font-size: 0.875rem;
    line-height: 1.25rem;
    white-space: nowrap;
    align-items: center;
    max-width: 100%;
    display: flex;
    .cn-icon {
      width: var(--size-xs);
      height: var(--size-xs);
      margin-left: calc(var(--size-base) / 2);
      margin-right: calc(var(--size-base) / 2);
    }
  }
  &__item {
    max-width: 100%;
    &--last {
      .cn-breadcrumbs {
        &__breadcrumb {
          color: var(--ab-canyon-breadcrumbs-breadcrumb-color-text-last);
        }
      }
    }
  }
}
</style>
